import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import MergeIcon from '@mui/icons-material/Merge';
import Sync from '@mui/icons-material/Sync';
import useToast from '../../hooks/useToast';
import { Controls } from '../../components/controls/Controls';
import ConfirmationModal from '../_common/ConfirmationModal';
import basicServiceHandler from '../../services/basicServiceHandler';
import { useApiClient, convertAxiosErrorToUserFacingMessage } from '../../context/ApiClientContext';

export default function TranslationCycleSection({ refreshLogs }) {
  const {
    toastSetSuccessNotification,
    toastSetErrorNotification,
  } = useToast();
  const apiClient = useApiClient();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleStagingSnapshot = async () => {
    basicServiceHandler(
      () => apiClient.runPipeline('ContentSnapshot'),
      () => {
        toastSetSuccessNotification('Snapshot started. Use the refresh button to monitor status.');
        setIsModalOpen(false);
        refreshLogs();
      },
      (error) => toastSetErrorNotification(convertAxiosErrorToUserFacingMessage(error)),
      {},
    );
  };

  const handlePlatformSync = async () => {
    basicServiceHandler(
      () => apiClient.runPipeline('DownloadTranslationsFromPlatform'),
      () => {
        toastSetSuccessNotification('Download started. Use the refresh button to monitor status.');
        setIsModalOpen(false);
        refreshLogs();
      },
      (error) => toastSetErrorNotification(convertAxiosErrorToUserFacingMessage(error)),
      {},
    );
  };

  const handleCopyDuplicateTranslations = async () => {
    basicServiceHandler(
      () => apiClient.runPipeline('CopyDuplicateTranslations'),
      () => {
        toastSetSuccessNotification('Duplicate translations copy started. Use the refresh button to monitor status.');
        setIsModalOpen(false);
        refreshLogs();
      },
      (error) => toastSetErrorNotification(convertAxiosErrorToUserFacingMessage(error)),
    );
  };

  return (
    <Box
      sx={{
        mt: 2,
        p: 2,
        border: '1px solid #c6c6c6',
        borderRadius: '4px',
      }}
    >
      <Typography
        variant="h5"
        align="center"
        sx={{ mb: 2, fontWeight: 'bold' }}
      >
        Translation Cycle
      </Typography>
      <Controls.Button
        sx={{ margin: '20px' }}
        variant="outlined"
        text="Take Staging Snapshot"
        onClick={() => setIsModalOpen(true)}
        startIcon={<CameraAltIcon />}
      />
      <ConfirmationModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={handleStagingSnapshot}
      >
        <Typography component="div">
          Are you sure you want to take a content snapshot from staging?
        </Typography>
      </ConfirmationModal>
      <Controls.Button
        sx={{ margin: '20px' }}
        variant="outlined"
        text="Copy duplicates"
        onClick={handleCopyDuplicateTranslations}
        startIcon={<MergeIcon />}
      />
      <Controls.Button
        sx={{ margin: '20px' }}
        variant="outlined"
        text="Download Translations From Lokalise"
        onClick={handlePlatformSync}
        startIcon={<Sync />}
      />
    </Box>
  );
}

TranslationCycleSection.propTypes = {
  refreshLogs: PropTypes.func.isRequired,
};
